import Image from 'next/legacy/image';
import linkButtonV2 from '../public/images/link_arrowV2.svg';
import { FC, useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { usePhoneNumber } from 'hooks/usePhoneNumber';
const ContactUsDialogV2 = dynamic(
  () => import('./ContactUsV2/ContactUsDialogV2'),
  { ssr: false }
);
interface RequestInfoBadgeV2Props {
  isSticky?: boolean;
  buttonClassName?: string;
  wrapperClassName?: string;
}
const RequestInfoBadgeV2: FC<RequestInfoBadgeV2Props> = ({
  isSticky,
  buttonClassName = '',
  wrapperClassName = '',
}) => {
  const router = useRouter();

  const [open, setOpen] = useState(false);

  const { areaCode, phoneEnding } = usePhoneNumber({
    open,
    routerPath: router.asPath,
  });

  const handlePopUpClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const openModalIfHashIsContact = () => {
      if (window.location.hash === '#contact') {
        setOpen(true);

        // Delete the hash from the URL
        const url = new URL(window.location.href);
        url.hash = '';
        window.history.replaceState(null, '', url.toString());
      }
    };

    openModalIfHashIsContact(); // initial
    window.addEventListener('hashchange', openModalIfHashIsContact);

    return () =>
      window.removeEventListener('hashchange', openModalIfHashIsContact);
  }, []);

  useEffect(() => {
    if (window.location.hash === '#contact' && !open && router.isReady) {
      setOpen(true);

      // Delete the hash from the URL
      const url = new URL(window.location.href);
      url.hash = '';
      window.history.replaceState(null, '', url.toString());
    }
  }, [router.isReady]);

  return (
    <div
      className={`flex flex-row items-center justify-center md:justify-end w-full md:w-auto md:mb-4 ${
        isSticky
          ? 'fixed bottom-0 left-0 right-0 z-50 bg-gold-backgroundV2 border-t border-gold-underline h-[60px] md:h-auto md:static md:z-auto md:bg-transparent md:border-0'
          : ''
      } ${wrapperClassName}`}
    >
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`cursor-pointer uppercase text-14-20-0.3 text-black flex flex-row items-center justify-center px-[30px] bg-gold border border-gold-borderV2 font-sohneBreitHalbfett hover-animation md:hover:bg-gold-hover ${
          isSticky
            ? 'gap-[20px] min-w-[222px] h-[40px] py-[7px] md:gap-[10px] md:min-w-[200px] md:h-[48px] md:py-[15px]'
            : 'gap-[10px] min-w-[200px] h-[48px] py-[15px]'
        } ${buttonClassName}`}
      >
        <p>Request Info</p>
        <Image src={linkButtonV2} alt="Link Arrow V2" />
      </button>
      <ContactUsDialogV2
        open={open}
        onClose={handlePopUpClose}
        isRequestInfoBuilding={true}
        phoneEnding={phoneEnding}
        areaCode={areaCode}
      />
    </div>
  );
};

export default RequestInfoBadgeV2;
